/**
 * @file PubSub.js
 * @description pub-sub pattern for messaging between components
 *
 * @copyright veriome labs, llc.  - all rights reserved.
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.md', which is part of this source code package.
 *
 * @author don michael
 * @since Jul 16, 2024 09:14
 */
// const util = require('util');

const pubSubEvents = {
    AnnotationsSaved: 'AnnotationsSaved',
    AnnotationDiseaseSubmitted: 'AnnotationDiseaseSubmitted',
    AnnotationGeneSymbolSubmitted: 'AnnotationGeneSymbolSubmitted',
    AnnotationClassificationCodeSubmitted: 'AnnotationClassificationCodeSubmitted',
    PublicationAnnotated: 'PublicationAnnotated',
    SupplementAnnotated: 'SupplementAnnotated',
    TableAnnotated: 'TableAnnotated',
};

class PubSub {
    constructor() {
        this.subscribers = {
            AnnotationsSaved: [],
            AnnotationDiseaseSubmitted: [],
            AnnotationGeneSymbolSubmitted: [],
            AnnotationClassificationCodeSubmitted: [],
            PublicationAnnotated: [],
            SupplementAnnotated: [],
            TableAnnotated: [],
        };
    }

    subscribe(subscriberId, pubSubEvent, fn) {
        // fn: function that gets called when event triggers

        if (subscriberId) {

            // prevent duplicate subscriptions
            let foundIndex = null;

            switch (pubSubEvent) {

                case (pubSubEvents.AnnotationsSaved):
                case (pubSubEvents.AnnotationDiseaseSubmitted):
                case (pubSubEvents.AnnotationGeneSymbolSubmitted):
                case (pubSubEvents.AnnotationClassificationCodeSubmitted):
                case (pubSubEvents.PublicationAnnotated):
                case (pubSubEvents.SupplementAnnotated):
                case (pubSubEvents.TableAnnotated):

                    foundIndex = this.subscribers[pubSubEvent].findIndex((item) => {
                        return item.subscriberId === subscriberId;
                    });

                    if (foundIndex === -1) {
                        this.subscribers[pubSubEvent].push({
                            subscriberId,
                            function: fn,
                        });
                    }
                    break;

                default:
                    break;
            }

        }
    }

    unsubscribe(subscriberId, pubSubEvent) {

        let foundIndex = null;

        switch (pubSubEvent) {

            // note: use of the switch/case is to enforce use of pubSubEvents.
            // all events should use the same case() statement.
            case (pubSubEvents.AnnotationsSaved):
            case (pubSubEvents.AnnotationDiseaseSubmitted):
            case (pubSubEvents.AnnotationGeneSymbolSubmitted):
            case (pubSubEvents.AnnotationClassificationCodeSubmitted):
            case (pubSubEvents.PublicationAnnotated):
            case (pubSubEvents.SupplementAnnotated):
            case (pubSubEvents.TableAnnotated):

                foundIndex = this.subscribers[pubSubEvent].findIndex((item) => {
                    return item.subscriberId === subscriberId;
                });

                if (foundIndex !== -1) {
                    this.subscribers[pubSubEvent].splice(foundIndex, 1);
                }
                break;

            default:
                break;
        }
    }

    publish(pubSubEvent, data) {

        switch (pubSubEvent) {

            case (pubSubEvents.AnnotationsSaved):
            case (pubSubEvents.AnnotationDiseaseSubmitted):
            case (pubSubEvents.AnnotationGeneSymbolSubmitted):
            case (pubSubEvents.AnnotationClassificationCodeSubmitted):
            case (pubSubEvents.PublicationAnnotated):
            case (pubSubEvents.SupplementAnnotated):
            case (pubSubEvents.TableAnnotated):

                this.subscribers[pubSubEvent].forEach((subscriber) => {
                    if (data) {
                        subscriber.function(data);
                    } else {
                        subscriber.function();
                    }

                });

                break;

            default:
                break;
        }
    }
}

// singleton
const pubSub = new PubSub();

export {
    pubSub,
    pubSubEvents,
};
